export default "__VITE_ASSET__b6843d5a__"